<template>
    <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
      <van-nav-bar
            title="环保管家智慧平台"
            id="topbar"
      >
        <template #right>
          <van-icon name="chat-o" size="20" :badge="messageCount" @click="toMessage" />
        </template>
      </van-nav-bar>
      <div style="padding:20px">
        <!--   头部信息   -->
        <div class="infoBox">
            <div class="infoWarp"  >
                <div class="infoLeft">
                  <img v-if="userInfo.avatar" class="headImg" :src="apiUrl + 'download/' + userInfo.avatar"/>
                  <img v-else class="headImg" src="../assets/headPortrait.png">
                  <div v-if="userInfo">
                      <div class="infoName">{{userInfo.nname}}</div>
                      <!--<div class="infoRole" v-if="userInfo.roleName && userInfo.roleName.indexOf('项目负责人')>=0">职位：项目负责人</div>-->
                      <!--<div class="infoRole">{{userInfo.thirdPartyName}}</div>-->
                      <div class="infoPhone">{{userInfo.mobile}}</div>
                      <van-dropdown-menu class="thirdPartyMenu">
                        <van-dropdown-item v-model="currentThirdPartyId" :options="thirdPartyList" @change="changeThirdParty" />
                      </van-dropdown-menu>

                  </div>
                </div>
            </div>
        </div>
        <van-row class="proTit" type="flex" justify="space-between" align="center">
            <van-col>我的项目</van-col>
            <van-col v-if="proList.length>0" @click="toProjectList">查看全部</van-col>
        </van-row>
        <div v-if="proList.length>0">
          <div v-for="(item,i) in proList" :key="i" class="parentPro">

            <van-row class="parentProName" type="flex" justify="space-between">
                <van-col class="proName" span="17">{{item.completeName}}</van-col>
                <van-col v-if="item.children.length>0" class="proStatus" span="7" style="text-align:right">{{item.proStatus}}</van-col>
                <van-col v-else class="proStatus" span="7" style="text-align:right">未添加任务</van-col>
            </van-row>

            <!--子项目-->
            <div style="width:100%;display: flex;flex-flow:row wrap;justify-content: space-between;padding-bottom:10px;">
              <div v-for="(child,ind) in item.children" :key="ind" style="width:48%;margin-top:10px;" @click="toCompanyList(child.id,child.completeName)">
                <div v-if="ind<4" class="childItem">
                  <div class="proName">{{child.name}}</div>
                  <van-row type="flex" justify="space-between" align="center">
                      <van-col class="proStatus">{{item.proStatus}}</van-col>
                  </van-row>
                  <div class="proOther">
                    开始时间:{{child.startDate}}
                  </div>
                  <div class="proOther">
                    结束时间:{{child.endDate}}
                  </div>
                </div>
                <div v-else-if="ind>3&&ind<6" class="childItem">
                  <div class="proName">{{child.completeName}}</div>
                  <van-row type="flex" justify="space-between" align="center">
                      <van-col class="proStatus">{{item.proStatus}}</van-col>
                  </van-row>
                  <div class="proOther">
                    开始时间:{{child.startDate}}
                  </div>
                  <div class="proOther">
                    结束时间:{{child.endDate}}
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
        <div v-else :style="{'width':clientWidth+'px','height':'220px','display':'table-cell','vertical-align': 'middle','text-align':'center'}">
          <div>
            <div><img style="width:150px;" src="../assets/noData.png"></div>
            <div>暂无项目</div>
          </div>
        </div>

        <!--
        <div style="width:100%;display: flex;flex-flow:row wrap;justify-content: space-between;">
          <div v-for="(item,i) in proList" :key="i" style="width:48%;" @click="toCompanyList(item.id,item.completeName)">
            <div v-if="i<4" class="proItem" style="margin-bottom:15px;">
              <div class="proName">{{item.completeName}}</div>
              <div class="proStatus">{{item.proStatus}}</div>
              <van-row class="proOther" type="flex" justify="space-between" align="center">
                  <van-col>{{item.startDate}} - {{item.endDate}}</van-col>
              </van-row>
            </div>
            <div v-else-if="i>3&&i<6" class="proItem">
              <div class="proName">{{item.completeName}}</div>
              <div class="proStatus">{{item.proStatus}}</div>
              <van-row class="proOther" type="flex" justify="space-between" align="center">
                  <van-col>{{item.startDate}} - {{item.endDate}}</van-col>
              </van-row>
            </div>
          </div>
        </div>-->

        <van-row class="proTit" type="flex" justify="space-between" align="center">
            <van-col>常用功能</van-col>
            <van-col></van-col>
        </van-row>
        <div class="commonFun">
          <div class="fun" style="background-color:#F69B4F;" @click="toAllCompanyList">
            <div class="funName">企业信息</div>
            <div class="funCount">{{companyCount}}</div>
          </div>
          <div class="fun" style="background-color:#1B75F6;" @click="toAllWorkRecords">
            <div class="funName">核查记录查询</div>
            <div class="funCount">{{workRecordsCount}}</div>
          </div>

        </div>

      </div>

      <van-tabbar v-model="active">
        <van-tabbar-item to="../homepage">
          <span>主页</span>
          <template #icon="props">
            <img :src="props.active ? icon.homeInActive : icon.homeActive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="../project/proList">
          <span>项目</span>
          <template #icon="props">
            <img :src="props.active ? icon.proInActive : icon.proActive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="../common/me">
          <span>我的</span>
          <template #icon="props">
            <img :src="props.active ? icon.meInActive : icon.meActive" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
</template>
<script>
    import $ from '@/fly'
    import Setting from '@/setting';
    import cookies from '@/libs/util.cookies'
    export default {
        name: 'homepage',
        data () {
            return {
                icon: {
                    homeInActive: require('../assets/inHomeIcon.svg'),
                    homeActive: require('../assets/homeIcon.svg'),
                    proInActive: require('../assets/inProIcon.svg'),
                    proActive: require('../assets/proIcon.svg'),
                    meInActive: require('../assets/inMeIcon.svg'),
                    meActive: require('../assets/meIcon.svg')
                },
                active: 0,
                clientHeight: window.screen.height,
                clientWidth: window.screen.width,
                proList: [],
                companyCount: 0,
                workRecordsCount: 0,
                apiUrl: Setting.apiBaseURL,
                userInfo: {},
                currentThirdPartyId: 0,
                thirdPartyList: [],
                messageCount: 0,
            }
        },
        computed: {
        },
        methods: {
            toMessage(){
              this.$router.push('/message/index')
            },
            getMessageCount(){
              $.get('overdue/notrectified/selectCount').then(res=>{
                this.messageCount = res
              })
            },
            toProjectList () {
                this.$router.push({ name: 'project-proList' });
            },
            toCompanyList (id, name) {
                localStorage.setItem('projectName', name);
                localStorage.setItem('projectId', id);
                localStorage.setItem('toBackURL',this.$router.currentRoute.fullPath)
                this.$router.push({ name: 'project-companyList' });
            },
            toAllCompanyList () {
                this.$router.push({ name: 'project-allCompanyList' });
            },
            toAllWorkRecords () {
                this.$router.push({ name: 'project-allWorkRecords' });
            },
            changeThirdParty () {
                cookies.set('third-party-id', this.currentThirdPartyId);
                this.loadData();
            },
            loadData () {
                $.get('projectLeaderStatistics/processing-project', {
                    pageNum: 1,
                    pageSize: 1
                }).then(res => {
                    this.proList = res.rows;
                    var projectIds = '';
                    this.proList.forEach(item => {
                        if (new Date() < Date.parse(item.startDate)) {
                            item.proStatus = '项目未开始';
                        } else if (new Date() > Date.parse(item.startDate) && new Date() < Date.parse(item.endDate)) {
                            item.proStatus = '项目进行中';
                        } else if (new Date() > Date.parse(item.endDate)) {
                            item.proStatus = '项目已结束';
                        }
                        item.children.forEach(child => {
                            if (new Date() < Date.parse(child.startDate)) {
                                child.proStatus = '项目未开始';
                            } else if (new Date() > Date.parse(child.startDate) && new Date() < Date.parse(child.endDate)) {
                                child.proStatus = '项目进行中';
                            } else if (new Date() > Date.parse(child.endDate)) {
                                child.proStatus = '项目已结束';
                            }
                            projectIds += child.id;
                            projectIds += ',';
                        })
                    })
                    projectIds = projectIds.substring(0, projectIds.length - 1);
                    localStorage.setItem('projectIds', projectIds);

                    var companyIds = '';
                    $.get('company/findCompanyByProjectId', {
                        projectIds: projectIds
                    }).then(res => {
                        this.companyCount = res.length;
                        res.forEach(item => {
                            companyIds += item.id;
                            companyIds += ',';
                        })
                        companyIds = companyIds.substring(0, companyIds.length - 1);
                        localStorage.setItem('companyIds', companyIds);
                        $.get('workRecords/getByProjectCompany', {
                            projectIds: projectIds,
                            companyIds: companyIds
                        }).then(res => {
                            this.workRecordsCount = res.length;
                        })
                    })
                })
            }
        },
        mounted () {
            this.userInfo = JSON.parse(localStorage.getItem('USER'));
            this.thirdPartyList = JSON.parse(localStorage.getItem('thirdPartyList'));
            this.currentThirdPartyId = cookies.get('third-party-id') - 0;
            this.loadData();
            this.getMessageCount()
            /**
            $.get('project/findThirdPartyManagerConsultantProject').then(res => {
                this.proList = res;
                var projectIds = '';
                this.proList.forEach(item => {
                    if (new Date() < Date.parse(item.startDate)) {
                        item.proStatus = '项目未开始';
                    } else if (new Date() > Date.parse(item.startDate) && new Date() < Date.parse(item.endDate)) {
                        item.proStatus = '项目进行中';
                    } else if (new Date() > Date.parse(item.endDate)) {
                        item.proStatus = '项目已结束';
                    }
                    projectIds += item.id;
                    projectIds += ',';
                })
                projectIds = projectIds.substring(0, projectIds.length - 1);
                localStorage.setItem('projectIds', projectIds);

                var companyIds = '';
                $.get('company/findCompanyByProjectId', {
                    projectIds: projectIds
                }).then(res => {
                    this.companyCount = res.length;
                    res.forEach(item => {
                        companyIds += item.id;
                        companyIds += ',';
                    })
                    companyIds = companyIds.substring(0, companyIds.length - 1);
                    localStorage.setItem('companyIds', companyIds);

                    $.get('workRecords/getByProjectCompany', {
                        projectIds: projectIds,
                        companyIds: companyIds
                    }).then(res => {
                        this.workRecordsCount = res.length;
                    })
                })
            }) */
        }
    }

</script>

<style lang="less" scoped>
  .infoBox{
        width: 100%;
        background-color: #1B75F6;
        padding: 30px 40px;
        border-radius: 6px;
    }
    .infoWarp{
        width: 100%;
        /*border: 1px solid red;*/
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        font-weight: bold;
        color: #FFFFFF;
    }
    .infoLeft{
        display: flex;
        align-items: center;
    }
    .headImg{
        width: 140px;
        height: 140px;
        border-radius: 50%;
        margin-right: 30px;
    }
    .infoName{
        font-size: 30px;
        line-height: 55px;
        overflow: hidden;
        font-weight: normal;
    }
    .infoRole{
      font-size: 22px;
      line-height: 55px;
      overflow: hidden;
      font-weight: 500;
    }
    .infoPhone{
        overflow: hidden;
        font-size: 30px;
        line-height: 50px;
        font-weight: 400;
    }
    .proTit{
      line-height: 100px;
    }
    .proTit .van-col:first-child{
      color: #464646;
      font-size: 15px;
      font-weight: 800;
    }
    .proTit .van-col:last-child{
      color: #464646;
      font-size: 12px;
      font-weight: 800;
    }
    .proName{
      font-size: 28px;
      color: #464646;
      font-weight: 800;
      line-height: 55px;
      overflow:hidden;
      text-overflow:ellipsis;
      white-space:nowrap;
    }
    .proStatus{
      font-size: 18px;
      color: #1B75F6;
      font-weight: 800;
      line-height: 55px;
    }
    .proOther{
      line-height: 55px;
      color: #999999;
      font-size: 15px;
      position: relative;
    }
    .proItem{
      background-color: #FFFFFF;
      padding: 15px 25px;
      font-size: 18px;
      width: 100%;
      border-radius: 6px;
    }
    .teamHeardImg{
      width: 22px;
    }
    .commonFun{
      width:100%;
      display: flex;
      flex-flow:row wrap;
      text-align: center;
    }
    .commonFun .fun{
      width:29%;
      padding: 20px 20px 10px 20px;
      margin-right: 20px;
      color: #FFFFFF;
      border-radius: 6px;
    }
    .commonFun .fun div:last-child{
      line-height: 40px;
    }
    .funName{
      font-size: 18px;
      font-weight: 800;
    }
    .funCount{
      font-size: 26px;
      font-weight: 800;
    }
    .parentPro{
      width:100%;
      background-color:#FFFFFF;
      margin-bottom:25px;
      padding:20px 20px 10px 20px;
    }
    .childItem{
      background-color: #F7F7F7;
      padding: 15px 25px;
      font-size: 18px;
      width: 100%;
      border-radius: 6px;
    }
    .parentProName{
      font-size: 28px;
      color: #464646;
      font-weight: 800;
      line-height: 55px;
      border-bottom:1px solid #F5F5F5;
      padding:5px 0px 10px 0px;
    }
    .thirdPartyMenu{
      height:30px;
      background-color: #1B75F6;
      margin-top: 10px;
      max-width: 400px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
</style>
